import _slicedToArray from "/home/travis/build/Adrian265431/viadeUO265431/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useDebugValue } from 'react';
import useLDflex, { toString } from './useLDflex';
/**
 * Evaluates the Solid LDflex expression into a list.
 */

export default function useLDflexList(expression) {
  var _useLDflex = useLDflex(expression, true),
      _useLDflex2 = _slicedToArray(_useLDflex, 1),
      items = _useLDflex2[0];

  useDebugValue(items, toString);
  return items;
}